'use strict';

var isValidMonth = require('is-valid-month');

var parseIntStrict = require('parse-int');

var parseYear = require('parse-year');

module.exports = {
  isPast: isPast,
  month: {
    parse: parseMonth,
    isValid: isValidMonth
  },
  year: {
    parse: parseYear,
    format: formatExpYear,
    isValid: isExpYearValid,
    isPast: isExpYearPast
  }
};

function isPast(month, year) {
  return Date.now() >= new Date(year, month);
}

function parseMonth(month) {
  return parseIntStrict(month);
}

function formatExpYear(year, strip) {
  year = year.toString();
  return strip ? year.substr(2, 4) : year;
}

function isExpYearValid(year) {
  if (typeof year !== 'number') return false;
  year = parseIntStrict(year);
  return year > 0;
}

function isExpYearPast(year) {
  return new Date().getFullYear() > year;
}